import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.dizest.editor.workflow.sidebar.info');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import showdown from 'showdown';
import $ from 'jquery';

@Component({
    selector: 'wiz-portal-dizest-editor-workflow-sidebar-info',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.dizest.editor.workflow.sidebar.info/view.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.markdown-body {
  font-size: 13px;
  line-height: 1.6;
}
.markdown-body h1, .markdown-body h2, .markdown-body h3, .markdown-body h4, .markdown-body h5, .markdown-body h6 {
  margin-top: 1em;
  margin-bottom: 0.5em;
  font-weight: 600;
  color: #18181b;
}
.markdown-body h1 {
  font-size: 1.25em;
}
.markdown-body h2 {
  font-size: 1.125em;
}
.markdown-body h3 {
  font-size: 1em;
}
.markdown-body p {
  margin-bottom: 0.75em;
  color: #3f3f46;
}
.markdown-body code {
  background: #f4f4f5;
  border-radius: 4px;
  padding: 0.125em 0.375em;
  font-size: 0.875em;
  color: #e11d48;
}
.markdown-body pre {
  background: #fafafa;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  padding: 0.75em 1em;
  overflow-x: auto;
}
.markdown-body pre code {
  background: none;
  padding: 0;
  color: inherit;
}
.markdown-body ul, .markdown-body ol {
  margin-bottom: 0.75em;
  padding-left: 1.5em;
}
.markdown-body li {
  margin-bottom: 0.25em;
}
.markdown-body blockquote {
  border-left: 3px solid #3b82f6;
  margin: 0.75em 0;
  padding: 0.5em 1em;
  color: #71717a;
  background: #fafafa;
  border-radius: 0 6px 6px 0;
}
.markdown-body a {
  color: #3b82f6;
  text-decoration: none;
}
.markdown-body a:hover {
  text-decoration: underline;
}
.markdown-body table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 0.75em;
}
.markdown-body table th, .markdown-body table td {
  border: 1px solid #e4e4e7;
  padding: 0.375em 0.75em;
  text-align: left;
  font-size: 0.875em;
}
.markdown-body table th {
  background: #fafafa;
  font-weight: 600;
}
.markdown-body img {
  max-width: 100%;
  border-radius: 6px;
}
.markdown-body hr {
  border: none;
  border-top: 1px solid #e4e4e7;
  margin: 1em 0;
}

nu-monaco-editor {
  display: block;
  min-height: 120px;
  border-top: none;
}`],
})
export class PortalDizestEditorWorkflowSidebarInfoComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    @Input() app: any;
    @Input() sidebar: any;

    public workflow: any;
    public descriptionEditable: boolean = false;
    private _metaChangeTimer: any = null;
    private static readonly META_CHANGE_DELAY = 500;
    public monaco: any = {
        value: '',
        language: 'markdown',
        theme: "vs",
        fontSize: 13,
        automaticLayout: true,
        scrollBeyondLastLine: false,
        wordWrap: true,
        roundedSelection: false,
        glyphMargin: false,
        scrollbar: {
            vertical: "hidden",
            handleMouseWheel: false,
        },
        minimap: {
            enabled: false
        }
    }

    public async ngOnInit() {
        await this.service.init();
        this.workflow = this.app.workflow;
        await this.service.render();
    }

    public async setEditable(value: boolean) {
        this.descriptionEditable = value;
        await this.service.render();
    }

    public async toggleEditable() {
        this.descriptionEditable = !this.descriptionEditable;
        await this.service.render();
    }

    /**
     * Track metadata field change with debounce.
     */
    public onMetaChange(...fields: string[]) {
        if (this._metaChangeTimer) clearTimeout(this._metaChangeTimer);
        this._metaChangeTimer = setTimeout(() => {
            this._metaChangeTimer = null;
            this.workflow.spec.trackChange('meta', 'update', undefined, fields);
        }, Component.META_CHANGE_DELAY);
    }

    public onDescriptionChange() {
        this.onMetaChange('description');
    }

    public async copyId() {
        if (!this.workflow?.spec?.data?.id) return;
        try {
            await navigator.clipboard.writeText(this.workflow.spec.data.id);
        } catch {
            const textarea = document.createElement('textarea');
            textarea.value = this.workflow.spec.data.id;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
        }
    }

    public showdown(text: string) {
        let converter = new showdown.Converter();
        return converter.makeHtml(text);
    }

    public async init(event: any) {
        let { editor } = event;

        let monaco_auto_height = async () => {
            const LINE_HEIGHT = 21;
            const el = editor.getDomNode();
            if (!el) return;
            let ui_line_counter = $(el).find('.margin-view-overlays .line-numbers').length;
            let counter = editor.getModel().getLineCount();
            let real_line = $(el).find('.view-lines .view-line').length;
            let height = real_line * LINE_HEIGHT;
            if (height < 105) height = 105;

            el.style.height = height + 'px';
            editor.layout();
            let resetcounter = 0;
            while (ui_line_counter != counter) {
                if (resetcounter > 20) break;
                ui_line_counter = $(el).find('.margin-view-overlays .line-numbers').length;
                counter = editor.getModel().getLineCount();
                real_line = $(el).find('.view-lines .view-line').length;
                real_line = real_line + 5;
                height = real_line * LINE_HEIGHT;

                if (height < 105) height = 105;
                el.style.height = height + 'px';
                editor.layout();
                resetcounter++;
            }
        }

        await monaco_auto_height();
        editor.onDidChangeModelDecorations(monaco_auto_height);
    }

}

export default PortalDizestEditorWorkflowSidebarInfoComponent;